import * as React from 'react';
import styled from 'styled-components';

interface IProps {
  name: string;
  onChange?: (value: string) => void;
  value: string;
  label?: string;
  readOnly?: boolean;
  style?: React.CSSProperties;
  placeholder?: string;
  error?: string;
  rows?: number;
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;
const Label = styled.label`
  margin-left: 4px;
  padding-bottom: 5px;
`;

const HintText = styled.div``;

const ErrorText = styled.div``;

const TextArea = ({
  name,
  onChange,
  value,
  label,
  readOnly,
  placeholder = '',
  rows,
  style = {},
}: IProps): React.ReactElement => {
  const changeHandler = (e: React.FormEvent<HTMLTextAreaElement>): void =>
    onChange(e.currentTarget.value);
  return (
    <Container>
      <Label htmlFor={name}>{label}</Label>
      <Control
        id={name}
        name={name}
        value={value}
        readOnly={readOnly}
        onChange={changeHandler}
        placeholder={placeholder}
        style={style}
        rows={rows}
        data-testid={name}
      />
    </Container>
  );
};
export { TextArea };

export const Control = styled.textarea`
  border-radius: 10px;
  border: 1px solid var(--color-separator);
  background-color: var(--color-surface-1);
  padding: 10px 5px;
  color: var(--color-control-text);
  width: 100%;
  resize: none;
  flex: 1;

  &:focus {
    outline: none;
  }
`;
